/*
  A Light DOM component wrapping a select & a label

  * Implements "sliding label" pattern to save space.
*/
import classes from './_select_field.module.scss';

export default class UaSelectField extends HTMLElement {
  /* @return {Boolean} - whether selected option is the empty option. */
  setEmptyOrNonEmpty() {
    this.empty = this.inputElement.selectedIndex < 1;
    this.classList.toggle(classes['is-empty'], this.empty);
  }

  /* Attach classes and attributes to elements */
  decorate() {
    this.inputElement = this.querySelector('select');
    this.labelElement = this.querySelector('label');
    this.classList.add(classes[`theme-${this.getAttribute('theme') || 'm4'}`]);
    this.classList.add(classes['ua-select-field']);
    this.inputElement.classList.add(classes['ua-select-field__input']);
    this.labelElement.classList.add(classes['ua-select-field__label']);
  }

  /* Set initial state */
  init() {
    this.setEmptyOrNonEmpty();
  }

  /* Attach event listeners */
  attachEvents() {
    this.inputElement.addEventListener('focus', () => {
      this.setEmptyOrNonEmpty();
    });
    this.inputElement.addEventListener('blur', () => {
      this.setEmptyOrNonEmpty();
    });
    this.inputElement.addEventListener('change', () => {
      this.setEmptyOrNonEmpty();
    });
  }

  connectedCallback() {
    this.decorate();
    this.attachEvents();
    this.init();
  }
}
